import * as React from "react";
import { forwardRef } from "react";
const SvgIcMap40 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 32V10.5715L15 6L26 10.5715L37 6V27.4285L26 32L15 27.4285L4 32ZM24.5 11.5725L16.5 8.24776V26.4275L24.5 29.7522V11.5725Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgIcMap40);
export { ForwardRef as ReactComponent };
